import { ModelFactory } from './ModelFactory'
import { $modelsLoader } from './$modelsLoader'

export const $models: { [modelName: string]: ModelFactory } = $modelsLoader.$models
